import { RouteService } from '../services/route.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-navigation-footer',
  templateUrl: './navigation-footer.component.html',
  styleUrls: ['./navigation-footer.component.css']
})
export class NavigationFooterComponent implements OnInit {
  @Input() hideHomeLink: boolean;
  @Input() showWarningText: boolean;

  constructor(private routeService: RouteService) {}

  ngOnInit() {
    const showWarningRoutes = [
      'login',
    ];
    const hideHomeLinkRoutes = ['login'];

    this.showWarningText = (showWarningRoutes.indexOf(this.getUrlEndsWith()) >= 0);
    this.hideHomeLink = (hideHomeLinkRoutes.indexOf(this.getUrlEndsWith()) >= 0);

    this.routeService.routeChange.subscribe(() => {
      this.showWarningText = (showWarningRoutes.indexOf(this.getUrlEndsWith()) >= 0);
      this.hideHomeLink = (hideHomeLinkRoutes.indexOf(this.getUrlEndsWith()) >= 0);
    });
  }

  getUrlEndsWith() {
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    return urlParts[urlParts.length - 1];
  }
}
